/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import WeekDays from '../common/WeekDays'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    header: false,
    form: false,
  },
  name: {
    displayName: 'RulesName',
  },
  dayOfWeek: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        default: 1,
        selectItems: WeekDays.getList(),
        itemText: 'name',
      },
    },
    form: false,
    header: false,
  },
  startTime: {
    type: IKDataEntity.Types.Time,
    header: false,
    form: false,
  },
  endTime: {
    type: IKDataEntity.Types.Time,
    header: false,
    form: false,
  },
  tempDiscountStr: {
    formConfig: {
      hint: 'threeTypeDiscount',

    },
  },
  priority: {
    formConfig: {
      default: 20,
      hint: 'higherPriorityWorkFirst',
    },
  },
  isActive: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
    },
  },
}
const config = {
  add: function (item) {
    if (item.dayOfWeek === 7) {
      item.dayOfWeek = 0
    }
    item.dayOfWeek = 0
    item.startTime = '00:00:00'
    item.endTime = '23:59:59'
    item.isActive = item.isActive ? 1 : 0
    return hillo.post('DiscountRule.php?op=add', item, {
      showLoading: true,
    })
  },
  edit: function (item) {
    if (item.dayOfWeek === 7) {
      item.dayOfWeek = 0
    }
    item.isActive = item.isActive ? 1 : 0
    return hillo.postWithUploadFile('DiscountRule.php?op=change', item, {
      showLoading: true,
    })
  },
  remove: function (id) {
    return hillo.post('DiscountRule.php?op=delete', { id: id })
  },
  load: async function (filter) {
    return (await hillo.get('DiscountRule.php?op=getList', { ...filter }))
      .content.map(function (item) {
        if (item.dayOfWeek === '0') {
          item.dayOfWeek = '7'
        }
        return item
      })
  },
}
export default IKDataEntity.ModelFactory(entity, config)
